import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';

export const useSwitchUserDialogStyles = createStyles(({ token }) => ({
  switchUserDialog: {
    '&&': {
      '.ant-modal-body': {
        padding: `${ThemeSpaces.SPACE_XL}px ${ThemeSpaces.SPACE_NORM_25}px ${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_25}px`,
      },
    },
  },

  icon: {
    '> img': {
      width: 54,
      height: 57,
    },
    '&::before': {
      top: 4,
      left: 11,
      right: 1,
      bottom: 14,
    },
  },

  noMarginFormItems: {
    display: 'flex',
    flexDirection: 'column',

    '.ant-form-item': {
      marginBottom: token.marginSM,
    },
  },
}));
